import { useMemo } from 'react';
import { useOrderTypeConfig } from '@/features/order-setup/hooks/useOrderSetup';
import {
  hasProductsOf,
  menuHealthOf,
  type MenuHealthCode,
  type OnlineChannel,
} from '../utils/menu-health';
import { useMenuActivations, useMenus, useMenuTrees } from './useMenu';

export function useMenuHealth(): MenuHealthCode | null {
  const { data: configs } = useOrderTypeConfig();
  const { data: menus } = useMenus();
  const menuIds = useMemo(() => (menus ?? []).map((m) => m.id), [menus]);
  const { trees, isLoading: treesLoading, hasError: treesFailed } = useMenuTrees(menuIds);
  const { data: activations } = useMenuActivations();

  return useMemo(() => {
    if (!configs || !menus) return null;
    const enabledOnlineChannels = configs.flatMap((c): OnlineChannel[] =>
      (c.orderType === 'PICKUP' || c.orderType === 'DELIVERY') && c.enabled ? [c.orderType] : [],
    );
    return menuHealthOf({
      enabledOnlineChannels,
      menuCount: menus.length,
      hasProducts: hasProductsOf(trees, treesLoading || treesFailed),
      liveChannels: activations ? activations.map((a) => a.channel) : null,
    });
  }, [configs, menus, trees, treesLoading, treesFailed, activations]);
}
